module.exports = __webpack_public_path__ + "img/paymentKoIcon.8b639fb3.svg";